import { render, staticRenderFns } from "./miniprogramCard.vue?vue&type=template&id=785a12b6"
import script from "./miniprogramCard.vue?vue&type=script&lang=js"
export * from "./miniprogramCard.vue?vue&type=script&lang=js"
import style0 from "./miniprogramCard.vue?vue&type=style&index=0&id=785a12b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports